/**
 * notifications.js — Notification Utility
 * ─────────────────────────────────────────────────────
 * FIX: clearNotifications() does NOT exist on react-notification-system.
 *      The ref only supports: addNotification, removeNotification, editNotification.
 *      That one call was crashing every notification in the entire app.
 *
 * CHANGES:
 *  1. Removed clearNotifications() call — does not exist, was the root crash
 *  2. Added null guard on NotificationManager ref
 *  3. Collapsed identical switch cases into single addNotification call
 *  4. Added autoDismiss (errors stay longer)
 */

class Notify {
  constructor() {
    this.notifyType = {
      Info: 'info',
      Success: 'success',
      Warning: 'warning',
      Error: 'error',
    };
  }

  createNotification = (type, message, NotificationManager) => {
    // Guard: ref may not be set yet (e.g. during initial mount)
    if (!NotificationManager || typeof NotificationManager.addNotification !== 'function') {
      console.warn('Notification ref not available. Message:', message);
      return;
    }

    // Map type to display title
    const titleMap = {
      info: 'Info',
      success: 'Success',
      warning: 'Warning',
      error: 'Error',
    };

    const level = type || 'info';
    const title = titleMap[level] || 'Info';

    NotificationManager.addNotification({
      title,
      message: message || '',
      level,
      position: 'tc',
      autoDismiss: level === 'error' ? 8 : 5,
    });
  };
}

export const notify = new Notify();
